import TimeframeModule from './datetime/timeframe';
import DatepickerModule from './datetime/datepicker';
import MonthpickerModule from './datetime/monthpicker';
import TimepickerModule from './datetime/timepicker';
import AnalyticsPanelModule from './analyticsPanel/analyticsPanel';
import HeaderModule from './header/header';
import SidebarModule from './sidebar/sidebar';
import FilterWidget from './filter/filterWidget';
import FilterHeader from './filter/filterHeader';
import CharsCountDownComponent from './miniComponents/charsCountDownComponent';
import CurrentGameHandler from './appStateHandlers/currentGameHandler';

export default angular.module('app.common', [
  TimeframeModule.name,
  DatepickerModule.name,
  MonthpickerModule.name,
  TimepickerModule.name,
  AnalyticsPanelModule.name,
  HeaderModule.name,
  SidebarModule.name,
  FilterWidget.name,
  FilterHeader.name,
  CharsCountDownComponent.name,
  CurrentGameHandler.name
]);



/** WEBPACK FOOTER **
 ** ./src/common/common.js
 **/